import { ApiError, notifyError } from "@marekl/adminer/api";
import { clearMe, readMe } from "@marekl/adminer";
import { queryClient } from "../lib/queryClient";

/**
 * Handle a mid-session 401. Wired as the single client's `onUnauthorized`
 * (`lib/api.ts`), which backs both the auth adapter and the REST data calls —
 * so it runs for every 401: auth and data, queries and mutations.
 *
 * Only reacts when a user was actually logged in: on first load the anonymous
 * `me()` probe also 401s, but with no cached user — we stay silent then so
 * nothing toasts on the login screen. On a genuine expiry we clear the cached
 * user (which makes `RequireAuth` redirect to `/login?returnTo=<current>`)
 * and toast the reason. Clearing `me` also dedupes bursts.
 */
export function handleSessionExpiry(): void {
  if (!readMe(queryClient)) return;
  clearMe(queryClient);
  notifyError(new ApiError(401, null));
}
